import { UiPricingPlanModel } from "../../../models";
import { FlatRatePricing } from "../../../utils/enterprise-pricing-calculator";
import {
    Description,
    Item,
    Price,
    PriceAppend,
    PriceDetail
} from "../UiPricingGrid.styles";

function formatPrice(price: number): string {
    return Number.isInteger(price) ? price.toString() : price.toFixed(2);
}

export type FlatRatePlanProps = {
    index: number;
    model: UiPricingPlanModel;
    planCount: number;
    pricing: FlatRatePricing;
};

export const FlatRatePlan = ({
    model,
    index,
    planCount,
    pricing
}: FlatRatePlanProps) => {
    const {
        highlight,
        description,
        beforePrice,
        afterPrice,
        beforeSmallPrice,
        afterSmallPrice
    } = model.content;

    return (
        <>
            <Item
                lgOrder={index + planCount * 1}
                highlight={highlight}
                first={index === 0}
                show={true}
            >
                <Price>
                    <PriceAppend>{beforePrice}</PriceAppend>
                    {formatPrice(pricing.annually)}
                    <PriceAppend>{afterPrice}</PriceAppend>
                </Price>
                <PriceDetail>
                    {[
                        beforeSmallPrice,
                        "$",
                        formatPrice(pricing.monthly),
                        " ",
                        afterSmallPrice
                    ].join("")}
                </PriceDetail>
            </Item>
            <Item
                lgOrder={index + planCount * 2}
                highlight={highlight}
                first={index === 0}
                show={true}
            >
                <Description>{description}</Description>
            </Item>
        </>
    );
};
